module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/assessment_achievements/5_fe6cdb8f3aaaef324ef41162545507fd.png";